var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7731 16.7107L12.6087 11.5426C13.6268 10.3216 14.2392 8.76115 14.2392 7.05688C14.2392 3.16877 11.0483 0.00738525 7.12327 0.00738525C3.19828 0.00738525 0 3.17246 0 7.06057C0 10.9487 3.1909 14.1101 7.11589 14.1101C8.78328 14.1101 10.3179 13.5383 11.5352 12.5829L16.7181 17.7658C17.0206 18.0683 17.4706 18.0683 17.7731 17.7658C18.0756 17.4633 18.0756 17.0132 17.7731 16.7107ZM1.51245 7.06057C1.51245 4.00616 4.02828 1.52352 7.11589 1.52352C10.2035 1.52352 12.7193 4.00616 12.7193 7.06057C12.7193 10.115 10.2035 12.5976 7.11589 12.5976C4.02828 12.5976 1.51245 10.1113 1.51245 7.06057Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c06bacb5736852e52b43637fda844de8.svg";
export { ForwardRef as ReactComponent };